import axios from 'axios';
import authHeader from '../../auth-header';

import tokenHeader from '../../token-header';

import baseUrl from '../../base-url';

const API_URL = baseUrl() + "/api/all/";

const getDataPeserta = 'hasil-post-test-peserta-pelatihan';
 

class HasilPostTestService {
    getDataPeserta(
        currentPage,
        pageSize,
        idWorkshopPelatihan,
        filter
    ) {
        var data = {
            pageNo: currentPage,
            pageSize: pageSize,
            idWorkshopPelatihan: idWorkshopPelatihan,
            filter: filter
        }
        return axios.get(
            API_URL + getDataPeserta,
            {
                params: data,
                headers: authHeader()
            });
    }
}

export default new HasilPostTestService();